import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';
import { isLocalApi } from 'utils/localApi';

export const getPrivateProjectBankArchiveDownload = async ({
  projectId,
  fileIds = [],
  folderIds = [],
}) => {
  const apiPath = `project-bank/private/project/${projectId}/download-archive`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: {
      fileIds,
      folderIds,
    },
    isLocalApiRequest: isLocalApi(process.env.REACT_APP_LOCAL_API_PROJECT_BANK),
  });

  const response = await axios(signedRequest);

  return response.data;
};
